import { createAction } from 'Helpers';
import servicesTypes from './types';

const poseActions = {
	getPosesRequest: createAction(servicesTypes.GET_POSES.REUQEST),
	getPosesSuccess: createAction(servicesTypes.GET_POSES.SUCCESS),
	getPosesFailure: createAction(servicesTypes.GET_POSES.FAILURE),
	clearPoses: createAction(servicesTypes.GET_POSES.CLEAR),

	getPoseItemRequest: createAction(servicesTypes.GET_POSES_ITEM.REUQEST),
	getPoseItemSuccess: createAction(servicesTypes.GET_POSES_ITEM.SUCCESS),
	getPoseItemFailure: createAction(servicesTypes.GET_POSES_ITEM.FAILURE),
	clearPoseItem: createAction(servicesTypes.GET_POSES_ITEM.CLEAR),

	setPosesRequest: createAction(servicesTypes.SET_POSES.REUQEST),
	setPosesSuccess: createAction(servicesTypes.SET_POSES.SUCCESS),
	setPosesFailure: createAction(servicesTypes.SET_POSES.FAILURE),
	clearAddedPos: createAction(servicesTypes.SET_POSES.CLEAR),

	deactivePosesRequest: createAction(servicesTypes.DEACTIVE_POSES.REUQEST),
	deactivePosesSuccess: createAction(servicesTypes.DEACTIVE_POSES.SUCCESS),
	deactivePosesFailure: createAction(servicesTypes.DEACTIVE_POSES.FAILURE),

	editPosesRequest: createAction(servicesTypes.EDIT_POSE.REUQEST),
	editPosesSuccess: createAction(servicesTypes.EDIT_POSE.SUCCESS),
	editPosesFailure: createAction(servicesTypes.EDIT_POSE.FAILURE),

	updatePosRequest: createAction(servicesTypes.UPDATE_POS.REUQEST),
	updatePosSuccess: createAction(servicesTypes.UPDATE_POS.SUCCESS),
	updatePosFailure: createAction(servicesTypes.UPDATE_POS.FAILURE),
	updatePosClear: createAction(servicesTypes.UPDATE_POS.CLEAR),
};

const packageActions = {
	getPackagesRequest: createAction(servicesTypes.GET_PACKAGES.REUQEST),
	getPackagesSuccess: createAction(servicesTypes.GET_PACKAGES.SUCCESS),
	getPackagesFailure: createAction(servicesTypes.GET_PACKAGES.FAILURE),
	clearPackages: createAction(servicesTypes.GET_PACKAGES.CLEAR),

	getProductsRequest: createAction(servicesTypes.GET_PRODUCTS.REUQEST),
	getProductsSuccess: createAction(servicesTypes.GET_PRODUCTS.SUCCESS),
	getProductsFailure: createAction(servicesTypes.GET_PRODUCTS.FAILURE),
};

const summaryAction = {
	summaryRequest: createAction(servicesTypes.SUMMARY.REQUEST),
	summarySuccess: createAction(servicesTypes.SUMMARY.SUCCESS),
	summaryFailure: createAction(servicesTypes.SUMMARY.FAILURE),
	summaryClear: createAction(servicesTypes.SUMMARY.CLEAR),
};

let servicesActions = {
	...poseActions,
	...packageActions,
	...summaryAction,
};

export default servicesActions;
